// Which entries of a ranked list (bids, awards) get a badge in the BI tables.

// The tenant and its competitors are what the table is for.
export const isFeaturedEntry = (entry) => !!(entry && (entry.is_tenant || entry.is_competitor));

/**
 * The entries to show from an amount-ordered list, at most `limit` unless the featured ones alone
 * exceed it: every featured entry (never pushed into the "+N" overflow), then the best-ranked
 * others up to the limit. The list's order is kept, so ranks still read in sequence.
 */
export function selectFeatured(list, limit) {
  const featured = list.filter(isFeaturedEntry);
  let openSlots = Math.max(limit - featured.length, 0);
  return list.filter((entry) => {
    if (isFeaturedEntry(entry)) return true;
    if (openSlots === 0) return false;
    openSlots -= 1;
    return true;
  });
}

/**
 * Zero-based rank of an entry in its amount-ordered list, where equal amounts share the rank of
 * the first of them (two bids at the same price are both #2).
 */
export function rankIn(list, entry) {
  let rank = list.indexOf(entry);
  if (rank < 0) return 0;
  const sameAmount = (a, b) => a.amount != null && b.amount != null && Number(a.amount) === Number(b.amount);
  while (rank > 0 && sameAmount(list[rank - 1], list[rank])) rank -= 1;
  return rank;
}
